import cn from 'classnames';
import { connect } from 'react-redux';
import { IState } from '../../state-management/types';
import { Platform } from '../../types';
import ChallengesRow from '../challenges-row';
import FavoritesRow from '../../components/favorites-row';
import FeaturedRow from '../../components/featured-row';
import MarketingRow from '../../components/marketing';
import Hero from '../../components/hero';
import LiveWorkoutsRow from '../../components/live-workouts-row';
import ManualWorkout from '../manual-workout';
import QuickFindsRow from '../../components/quick-finds-row';
import RecommendedWorkoutsRow from '../recommended-workouts-row';
import RecommendedSeriesRow from '../recommended-series-row';
import UpNextRow from '../../components/up-next-row';
import MatrixClub from '../matrix-club';
import './index.scss';

export interface IDashboardProps {
  platform: Platform;
  softwareNumber: string;
}

export function Dashboard({ platform, softwareNumber }: IDashboardProps): JSX.Element {
  if (!softwareNumber) {
    return null;
  }

  return (
    <>
      <div className={cn('dashboard', platform)}>
        <Hero />
        <MatrixClub />
        <FeaturedRow />
        <MarketingRow />
        <UpNextRow />
        <ChallengesRow />
        <RecommendedWorkoutsRow />
        <RecommendedSeriesRow />
        <LiveWorkoutsRow />
        <QuickFindsRow />
        <FavoritesRow />
      </div>
      <ManualWorkout />
    </>
  );
}

export function mapStateToProps({ platform, softwareNumber }: IState): IDashboardProps {
  return { platform, softwareNumber };
}

export default connect(mapStateToProps)(Dashboard);
